var WAYCEL_PRODUCT_FORM_VARIANT_CONFIRMED_PROPERTY = '_waycel_variant_confirmed';
var WAYCEL_PRODUCT_FORM_CONFIRMED_VARIANT_ID_PROPERTY = '_waycel_confirmed_variant_id';

function appendWaycelProductFormVariantConfirmationProperties(formData) {
  const variantId = formData.get('id');
  if (!variantId) return;

  formData.set(`properties[${WAYCEL_PRODUCT_FORM_VARIANT_CONFIRMED_PROPERTY}]`, 'true');
  formData.set(`properties[${WAYCEL_PRODUCT_FORM_CONFIRMED_VARIANT_ID_PROPERTY}]`, String(variantId));
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = this.getCartTarget();
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['X-Waycel-Cart-Source'] = 'product-form';
        delete config.headers['Content-Type'];

        this.cart = this.getCartTarget();
        if (!this.cart) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          this.cart = this.getCartTarget();
        }

        const selectedVariantId = this.resolveSelectedVariantId();
        if (selectedVariantId && this.variantIdInput) {
          this.variantIdInput.disabled = false;
          this.variantIdInput.value = selectedVariantId;
        }

        const formData = new FormData(this.form);
        if (selectedVariantId) formData.set('id', selectedVariantId);
        appendWaycelProductFormVariantConfirmationProperties(formData);
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      if (this.cart && typeof this.cart.renderContents === 'function') {
                        this.cart.renderContents(response);
                      }
                      this.openCartIfAvailable();
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  this.cart.renderContents(response);
                }
                this.openCartIfAvailable();
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        if (!this.form) return null;

        const formId = this.form.id;
        const formScopedVariantInput = this.form.querySelector('[name=id]');
        if (formScopedVariantInput) return formScopedVariantInput;
        if (!formId) return null;

        const escapedFormId = window.CSS && window.CSS.escape ? window.CSS.escape(formId) : formId;

        return (
          document.querySelector(`[form="${escapedFormId}"][name="id"]:checked`) ||
          document.querySelector(`[form="${escapedFormId}"][name="id"]`)
        );
      }

      getCartTarget() {
        return (
          document.querySelector('cart-drawer.waycel-cart-sidebar-host') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification')
        );
      }

      openCartIfAvailable() {
        if (this.cart && typeof this.cart.open === 'function') {
          this.cart.open();
        }
      }

      resolveSelectedVariantId() {
        const productInfo = this.closest('product-info');
        const selectedVariantId = productInfo ? this.getSelectedVariantIdFromProductInfo(productInfo) : '';
        const inputVariantId = this.variantIdInput?.value || '';
        const urlVariantId =
          productInfo?.dataset.updateUrl !== 'false' ? new URLSearchParams(window.location.search).get('variant') : '';

        return selectedVariantId || inputVariantId || urlVariantId;
      }

      getSelectedVariantIdFromProductInfo(productInfo) {
        const selectedVariantJson = productInfo?.querySelector('variant-selects [data-selected-variant]')?.textContent;
        if (!selectedVariantJson) return '';

        try {
          return String(JSON.parse(selectedVariantJson)?.id || '');
        } catch (error) {
          return '';
        }
      }
    }
  );
}
